export { NFTMarketRouter } from '@f8n/f8n-contracts/dist/abis/NFTMarketRouter.generated';
